module.exports = __webpack_public_path__ + "static/media/success.da423e0b.gif";